'use client'

import { Toaster as Sonner, ToasterProps } from 'sonner'
import './styles.css'

const Toaster = (props: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

Toaster.displayName = 'Toaster'

export { Toaster }
